import { observer } from "mobx-react";
import React, { Component } from "react";

type AppIconProps = {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
};

export const AppIcon = observer(function AppIcon({
  name,
  size = 24,
  color = "inherit",
  style,
  className,
  onClick,
}: AppIconProps) {
  return (
    <span
      className={`material-symbols-outlined ${className || ""}`}
      style={{
        fontSize: size,
        color,
        lineHeight: 1,
        verticalAlign: "middle",
        ...style,
      }}
      onClick={onClick}
    >
      {name}
    </span>
  );
});
